var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFoxBody = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 70.2696,
    height: 140.519,
    viewBox: "0 0 70.2696 140.519",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M69.3788 43.9988C69.2121 41.8932 64.5288 41.371 62.501 38.271C61.8621 37.2988 61.6955 35.7043 61.6955 33.9599C61.6955 32.4377 61.8177 30.8099 61.8732 29.3821C62.0065 26.0377 61.8677 24.1988 61.901 18.5432C61.9288 14.0543 61.3732 9.07657 59.3065 7.9099C57.3899 6.82101 54.2954 8.93768 49.901 12.9766C47.451 15.2321 45.8399 17.1766 44.1621 18.5655C44.0621 18.6488 43.9621 18.7377 43.8565 18.821C43.7565 18.8988 41.2399 18.2488 39.7677 17.9544C39.451 17.8932 39.2565 17.521 39.0954 16.8655C38.7399 15.3932 38.551 12.4599 37.5232 8.17102C36.2455 2.83213 34.5121 0.221008 32.0066 0.00434144C29.8955 -0.173436 26.2343 5.14324 23.4121 9.59324C21.0732 13.2766 20.901 13.6543 19.9899 14.9821C19.3232 15.9488 18.5621 17.0932 17.7343 18.2432C16.0288 20.6099 14.0621 22.971 12.1788 23.721C8.62322 25.1321 5.87877 23.2321 4.55655 24.871C3.28988 26.4432 4.66767 26.7377 4.95101 27.0099C12.5677 28.9321 14.3899 39.0766 17.9121 38.1988C20.9121 37.4488 22.8899 40.6377 29.0732 41.4099C35.2232 42.1766 35.9288 45.4932 40.5399 44.6321C50.2454 42.8266 58.3621 42.3877 67.7843 45.8155C67.301 45.0766 69.4843 45.3543 69.3788 43.9988Z",
    fill: "url(#paint0_linear_0_15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M53.8124 24.9987C57.0013 28.6931 60.2902 32.4376 61.6957 33.9653C61.6957 32.4431 61.8179 30.8153 61.8735 29.3876C62.0068 26.0431 61.8679 24.2042 61.9013 18.5487C61.929 14.0598 61.3735 9.082 59.3068 7.91534C57.3901 6.82645 54.2957 8.94311 49.9012 12.982C47.4512 15.2376 45.8402 17.182 44.1624 18.5709C46.1624 19.2876 50.5179 21.182 53.8124 24.9987Z",
    fill: "url(#paint1_linear_0_15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M39.101 16.8655C38.7454 15.3932 38.5566 12.4599 37.5288 8.17101C36.251 2.83213 34.5176 0.221008 32.0121 0.00434144C29.901 -0.173436 26.2399 5.14324 23.4177 9.59324C21.0788 13.2766 20.9066 13.6543 19.9954 14.9821C19.3288 15.9488 18.5676 17.0932 17.7399 18.2432C20.1565 17.8432 24.4732 17.071 28.701 16.2877C32.8677 15.5099 36.7454 16.2155 39.0954 16.8655H39.101Z",
    fill: "url(#paint2_linear_0_15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M67.7842 45.8154C58.6176 42.4821 50.6009 42.8098 41.1176 44.5321C40.162 44.7043 39.3842 44.8598 38.3398 44.7265C40.462 46.9876 34.2843 52.8321 26.9398 51.4321C24.4343 50.9543 22.4065 50.1821 20.7898 49.2432C15.3676 46.0821 14.7509 41.0765 16.7231 38.5265C16.812 38.4154 16.9009 38.2987 17.0009 38.1821C14.0176 37.3209 11.8843 28.7709 4.95092 27.0209C5.01203 27.0765 5.02314 27.1321 4.95092 27.1987C4.26758 27.8432 1.3787 26.5932 0.662028 28.4654C0.0786952 29.9987 3.17869 30.2765 2.95091 30.9876C2.63425 31.9598 0.412022 31.7154 0.117578 32.6932C-0.376866 34.3265 0.684253 34.2265 3.38981 36.6765C4.75647 37.9098 6.53425 39.7932 8.75092 42.8709C12.2731 47.7709 12.512 59.0043 12.0787 66.7209C11.862 70.5821 9.89536 79.1654 9.67314 83.6987C9.43981 88.3598 9.92869 92.5543 10.0454 96.2487C10.0731 98.0598 10.0453 100.588 9.62312 102.377C8.56757 107.693 5.42869 108.543 4.28424 115.532C2.56202 126.049 14.0065 129.999 13.8843 130.032C13.8565 130.038 13.8176 130.049 13.7731 130.06C14.3565 130.127 14.9287 130.199 15.4842 130.265C17.9842 130.571 20.1565 130.86 22.0231 131.121C22.7454 131.221 23.512 131.321 24.1509 131.415C23.9565 132.565 23.6509 133.899 23.3565 134.76C22.9454 135.965 22.5176 138.16 23.1176 139.165C24.3176 141.193 31.7565 140.888 32.1009 138.493C32.2731 137.327 32.3843 135.899 32.4509 134.282C32.4509 134.288 32.4509 134.293 32.4509 134.299C33.2954 134.26 33.3509 134.271 33.9009 134.304C33.9065 134.543 33.9954 136.765 34.2509 138.493C34.6009 140.888 42.0342 141.193 43.2342 139.165C43.8287 138.165 43.412 135.971 42.9954 134.76C42.8009 134.193 42.5954 133.393 42.4231 132.571C43.3565 132.382 54.1564 130.171 55.0676 130.026C55.0787 129.982 55.1398 129.943 55.2509 129.904C60.2009 128.193 65.8176 120.615 63.2231 113.532C61.7398 109.477 58.9842 107.554 57.4398 104.849C54.2453 99.2432 56.6842 97.9321 55.2787 82.9709C54.6676 76.4543 52.9565 68.7765 52.262 64.8043C50.8842 56.9154 52.6676 56.9654 57.3176 55.6709C63.3176 53.9987 65.362 55.0543 66.1676 53.1765C66.5509 52.2932 65.1231 51.6709 65.4342 50.7598C65.9287 49.3321 69.9342 50.5209 70.2287 49.0376C70.6065 47.1321 68.2565 46.5321 67.7898 45.8209L67.7842 45.8154Z",
    fill: "url(#paint3_linear_0_15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.6,
    d: "M67.7842 45.8154C58.6176 42.4821 50.6009 42.8098 41.1176 44.5321C40.162 44.7043 39.3842 44.8598 38.3398 44.7265C40.462 46.9876 34.2843 52.8321 26.9398 51.4321C24.4343 50.9543 22.4065 50.1821 20.7898 49.2432C15.3676 46.0821 14.7509 41.0765 16.7231 38.5265C16.812 38.4154 16.9009 38.2987 17.0009 38.1821C14.0176 37.3209 11.8843 28.7709 4.95092 27.0209C5.01203 27.0765 5.02314 27.1321 4.95092 27.1987C4.26758 27.8432 1.3787 26.5932 0.662029 28.4654C0.0786953 29.9987 3.17869 30.2765 2.95091 30.9876C2.63425 31.9598 0.412022 31.7154 0.117578 32.6932C-0.376866 34.3265 0.684253 34.2265 3.38981 36.6765C4.75647 37.9098 6.53425 39.7932 8.75092 42.8709C12.2731 47.7709 12.512 59.0043 12.0787 66.7209C11.862 70.5821 9.89536 79.1654 9.67314 83.6987C9.43981 88.3598 9.92869 92.5543 10.0454 96.2487C10.0731 98.0598 10.0453 100.588 9.62312 102.377C8.56757 107.693 5.42869 108.543 4.28424 115.532C2.56202 126.049 14.0065 129.999 13.8843 130.032C13.8565 130.038 13.8176 130.049 13.7731 130.06C14.3565 130.127 14.9287 130.199 15.4842 130.265C17.9842 130.571 20.1565 130.86 22.0231 131.121C22.7454 131.221 23.512 131.321 24.1509 131.415C23.9565 132.565 23.6509 133.899 23.3565 134.76C22.9454 135.965 22.5176 138.16 23.1176 139.165C24.3176 141.193 31.7565 140.888 32.1009 138.493C32.2731 137.327 32.3842 135.899 32.4509 134.282C32.4509 134.288 32.4509 134.293 32.4509 134.299C33.2954 134.26 33.3509 134.271 33.9009 134.304C33.9065 134.543 33.9954 136.765 34.2509 138.493C34.6009 140.888 42.0342 141.193 43.2342 139.165C43.8287 138.165 43.412 135.971 42.9953 134.76C42.8009 134.193 42.5954 133.393 42.4231 132.571C43.3565 132.382 54.1565 130.171 55.0676 130.026C55.0787 129.982 55.1398 129.943 55.2509 129.904C60.2009 128.193 65.8176 120.615 63.2231 113.532C61.7398 109.477 58.9842 107.554 57.4398 104.849C54.2453 99.2432 56.6842 97.9321 55.2787 82.9709C54.6676 76.4543 52.9565 68.7765 52.262 64.8043C50.8842 56.9154 52.6676 56.9654 57.3176 55.6709C63.3176 53.9987 65.362 55.0543 66.1676 53.1765C66.5509 52.2932 65.1231 51.6709 65.4342 50.7598C65.9287 49.3321 69.9342 50.5209 70.2287 49.0376C70.6065 47.1321 68.2565 46.5321 67.7898 45.8209L67.7842 45.8154Z",
    fill: "url(#paint4_linear_0_15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M22.1178 131.121C20.2511 130.86 18.0789 130.571 15.5789 130.266C15.0233 130.199 14.4567 130.127 13.8678 130.06C13.1511 130.21 10.2067 130.688 8.06221 133.31C7.3011 134.238 7.04555 134.966 7.03999 135.566C7.03999 135.966 7.14555 136.31 7.3011 136.61C8.00666 137.982 11.44 137.849 13.4233 137.321C14.5456 137.021 16.0011 136.688 17.6178 136.366C19.3789 136.016 21.3289 135.677 23.2511 135.41C23.3122 135.194 23.3733 134.977 23.4511 134.76C23.7344 133.932 24.0455 132.605 24.24 131.432C23.5844 131.332 22.8678 131.232 22.1122 131.121H22.1178Z",
    fill: "url(#paint5_linear_0_15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M60.0844 133.61C59.6344 133.06 58.8567 132.438 57.5955 131.705C55.9955 130.777 54.5677 130.366 54.7622 130.082C54.5066 130.121 54.2511 130.166 53.9844 130.221C48.5622 131.321 44.9178 131.955 42.4567 132.31C42.64 133.227 42.8733 134.138 43.0844 134.76C43.1567 134.971 43.2233 135.182 43.2789 135.394C43.3011 135.482 43.3233 135.571 43.3455 135.66C48.0789 136.382 50.1622 137.277 53.9678 137.471C58.2289 137.688 59.5511 137.26 60.2733 135.982C60.6622 135.288 60.8566 134.555 60.0844 133.61Z",
    fill: "url(#paint6_linear_0_15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.38,
    d: "M24.0786 116.693C22.2619 109.799 16.673 104.427 9.6397 102.871C9.5397 103.31 9.41192 103.732 9.26748 104.149C9.26748 104.166 9.25636 104.177 9.25081 104.193C9.0397 104.804 8.79525 105.399 8.47858 105.966C6.92302 108.788 5.15637 110.76 4.37859 115.538C2.65637 126.054 14.1008 130.004 13.9786 130.038C13.9508 130.043 13.9119 130.054 13.8675 130.066C14.4508 130.132 15.023 130.204 15.5786 130.271C18.0786 130.577 20.2508 130.866 22.1175 131.127C23.323 129.06 24.1508 126.749 24.5064 124.282C24.4397 121.971 24.2897 119.388 24.0786 116.693Z",
    fill: "url(#paint7_radial_0_15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M31.6954 109.699C31.3232 110.144 31.101 113.06 30.6232 113.305C30.2399 113.499 30.051 111.016 29.6565 108.777C29.551 108.171 29.1399 106.21 29.0343 105.627C28.5343 102.821 28.5288 103.044 28.1121 100.755C28.0288 102.582 27.8621 103.071 27.5288 105.871C27.3677 107.232 27.1343 108.866 26.9454 109.771C26.7788 110.56 26.5177 107.621 26.3621 106.849C25.5843 103.099 25.0399 102.094 23.9899 98.3602C23.3954 96.2491 21.5343 94.2991 21.351 92.9546C22.201 98.7158 23.4288 108.249 24.0899 116.699C24.301 119.388 24.451 121.971 24.5176 124.288C24.5788 126.51 24.5621 128.494 24.4343 130.082C24.401 130.477 24.3399 130.944 24.2566 131.444C24.0621 132.616 23.751 133.944 23.4677 134.771C23.3955 134.988 23.3288 135.205 23.2676 135.421C22.8343 137.021 22.8343 138.51 23.2288 139.177C24.4288 141.205 31.8677 140.899 32.2121 138.505C32.3843 137.332 32.4954 135.905 32.5621 134.282C32.8121 128.171 32.3843 119.194 31.7065 109.705L31.6954 109.699Z",
    fill: "url(#paint8_linear_0_15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M43.2845 135.394C43.229 135.182 43.1623 134.971 43.0901 134.76C42.8734 134.132 42.6456 133.221 42.4623 132.31C42.3012 131.505 42.1679 130.694 42.1179 130.077C41.4456 121.638 43.8123 102.316 45.2012 92.9546C45.0179 94.3046 43.1568 96.2491 42.5623 98.3602C41.5123 102.094 40.9679 103.099 40.1901 106.849C40.029 107.627 39.7734 110.566 39.6068 109.771C39.4123 108.866 39.1846 107.232 39.0234 105.871C38.6901 103.066 38.5234 102.582 38.4401 100.755C38.0234 103.044 38.0234 102.827 37.5179 105.627C37.4123 106.205 37.0068 108.166 36.8957 108.777C36.5012 111.021 36.3123 113.499 35.929 113.305C35.4457 113.06 35.229 110.144 34.8568 109.699C34.179 119.182 33.7512 128.16 34.0012 134.271C34.0679 135.894 34.179 137.327 34.3512 138.499C34.7012 140.894 42.1345 141.199 43.3345 139.171C43.7068 138.538 43.7234 137.166 43.3568 135.66C43.3346 135.571 43.3179 135.482 43.2901 135.394H43.2845Z",
    fill: "url(#paint9_linear_0_15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    opacity: 0.6,
    d: "M32.5287 65.0712C32.5287 65.0712 24.6565 70.8879 26.7787 84.4768C28.4787 95.3601 29.8676 97.8768 30.9398 104.782C32.012 111.688 33.1564 119.66 33.1564 119.66C33.1564 119.66 34.1231 111.949 35.4231 104.605C36.3509 99.3545 38.212 92.2879 39.212 83.7934C40.8176 70.1156 32.5287 65.0656 32.5287 65.0656V65.0712Z",
    fill: "url(#paint10_linear_0_15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M24.8178 34.5492C29.3344 35.1547 32.5455 42.1269 37.5678 44.2103C41.5789 45.8714 34.9511 52.9658 26.9455 51.4325C16.1622 49.3769 14.0956 41.9325 16.7289 38.5269C18.14 36.6992 21.0289 34.0381 24.8178 34.5492Z",
    fill: "#FFC635"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M24.6789 35.6712C23.0678 35.1435 21.9456 35.549 21.4567 36.1157C20.8567 36.8101 20.9456 38.699 22.9233 39.349C24.8011 39.9657 26.44 38.7601 26.5122 37.799C26.5622 37.1157 26.0956 36.1324 24.6734 35.6712H24.6789Z",
    fill: "#00073A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M43.0621 31.4213C45.001 31.9658 45.6621 33.6047 43.9121 37.1825C42.5399 39.9936 41.3176 39.8658 39.4954 39.3269C38.5399 39.0436 37.3954 37.5825 38.4343 35.438C39.851 32.5102 41.0343 30.8547 43.0621 31.4269V31.4213Z",
    fill: "url(#paint11_linear_0_15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M40.3412 36.8678C40.5725 36.3833 40.3987 35.8179 39.9529 35.6051C39.5071 35.3923 38.9582 35.6126 38.7268 36.0971C38.4955 36.5817 38.6694 37.147 39.1152 37.3598C39.5609 37.5726 40.1099 37.3524 40.3412 36.8678Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M26.9952 24.7434C29.5508 25.3379 29.2675 27.5712 27.5175 30.8823C26.423 32.9545 25.2341 32.9045 23.4175 32.3656C22.4675 32.0879 21.2064 31.049 22.6897 28.2101C23.8897 25.9045 25.3897 24.3656 27.0008 24.7434H26.9952Z",
    fill: "url(#paint12_linear_0_15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M24.5787 30.2325C24.8166 29.7341 24.6392 29.1532 24.1823 28.9351C23.7254 28.717 23.1622 28.9442 22.9242 29.4426C22.6863 29.941 22.8638 30.5219 23.3206 30.74C23.7775 30.9581 24.3408 30.7309 24.5787 30.2325Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_15",
    x1: 48.401,
    y1: -0.856769,
    x2: 26.2065,
    y2: 67.3043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FF9C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF6700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_15",
    x1: 54.405,
    y1: 24.0211,
    x2: 66.268,
    y2: 5.23391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FF6600",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FF6600",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FF6600",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF6600",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FD4737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB2872"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_15",
    x1: 28.5256,
    y1: 15.9434,
    x2: 31.1617,
    y2: -6.16496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FF6600",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FF6600",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FF6600",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FF6600",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FF6600",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FF6600",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FF6600",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF6600",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FD4737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#FB2872"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_15",
    x1: 35.1342,
    y1: 24.9376,
    x2: 35.1342,
    y2: 147.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FF7408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FF8A14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FF9B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFA724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFAE27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FFB029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FF9218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FE5D0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FD4A32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FC3B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FB3062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FB2A6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FB2872"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_15",
    x1: 35.1342,
    y1: 24.9376,
    x2: 35.1342,
    y2: 147.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB49",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FFD13A",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF8F17",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_15",
    x1: 63.09,
    y1: 114.866,
    x2: -11.6211,
    y2: 144.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#BE0449",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FB2872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#A31C5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#4C104A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#15093E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00073A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_15",
    x1: 21.2344,
    y1: 121.994,
    x2: 72.2178,
    y2: 141.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE0449",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FB2872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00073A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_0_15",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.56193 124.16) scale(31.6445 31.6444)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE546",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFD73E",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFC031",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FFA01F",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF7709",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FF6600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_0_15",
    x1: 26.3121,
    y1: 93.7046,
    x2: 28.4843,
    y2: 151.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#BE0449",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#BF054A",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#C2084C",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#C70D51",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#CE1457",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#D71E5F",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D81F60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D31E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C71D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B31A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#971754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#73134E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#460E46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#13093D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00073A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_0_15",
    x1: 40.5068,
    y1: 83.1158,
    x2: 38.1068,
    y2: 151.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81F60",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D81F60",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D81F60",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#D81F60",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D81F60",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D81F60",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D81F60",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D81F60",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#D81F60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#D21E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C21C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#A81957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#841551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#551049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#1D0A3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00073A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_0_15",
    x1: 32.7565,
    y1: 76.6768,
    x2: 35.1009,
    y2: 128.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFE745",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FFDE3D",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFCF2F",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFBB1C",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FFA105",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_0_15",
    x1: 43.2399,
    y1: 28.6436,
    x2: 40.4454,
    y2: 39.4825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A030B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#00073A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_0_15",
    x1: 27.2786,
    y1: 22.5934,
    x2: 24.573,
    y2: 31.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A030B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#00073A"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFoxBody);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fox-body.061370addb51c1d042a58889c0e18b50.svg";